import dayjs from 'dayjs';

export const convertDateFormatNoYear = (date: string) => dayjs(date).format('MMM D');
